import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Logo from 'components/Logo';

const StyledHeader = styled.div`
  display: flex;
  background-color: #FFF;
  padding: 0 ${({ theme }) => theme.spacing * 2}px;

  > * {
    flex-grow: 1;
    flex-basis: 0;
  }
`;

const RightHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CenterHeader = styled.div`

`;

const LeftHeader = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const ButtonContainer = styled.div`
  margin: auto 0;

  button {
    padding: ${({ theme }) => theme.spacing * 2}px 0;
  }
`;

const ButtonContainerHideBelowMd = styled(ButtonContainer)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

const ButtonContainerHideAboveMd = styled(ButtonContainer)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md + 1}px) {
    display: none;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing}px 0;

  a {
    display: flex;
  }
`;

const renderLogo = (logoWrapper) => {
  if (logoWrapper) {
    const { elementType: ElementType, elementProps } = logoWrapper;
    return <ElementType {...elementProps}><Logo /></ElementType>;
  }
  return <Logo />;
};

const Header = ({ backButton, menuButton, logoWrapper, subscriptionsButton, userButton }) => {

  return (
    <StyledHeader>
      <LeftHeader>
        {backButton && <ButtonContainer>{backButton}</ButtonContainer>}
        <ButtonContainerHideAboveMd>{menuButton}</ButtonContainerHideAboveMd>
        <ButtonContainerHideBelowMd>{subscriptionsButton}</ButtonContainerHideBelowMd>
      </LeftHeader>
      <CenterHeader>
        <LogoContainer>{renderLogo(logoWrapper)}</LogoContainer>
      </CenterHeader>
      <RightHeader>
        <ButtonContainerHideAboveMd>{subscriptionsButton}</ButtonContainerHideAboveMd>
        <ButtonContainer>{userButton}</ButtonContainer>
      </RightHeader>
    </StyledHeader>
  );
};

Header.propTypes = {
  menuButton: PropTypes.element,
  backButton: PropTypes.element,
  userButton: PropTypes.element,
  subscriptionsButton: PropTypes.element,
  logoWrapper: PropTypes.shape({
    elementType: PropTypes.elementType.isRequired,
    elementProps: PropTypes.shape({}).isRequired,
  }),
};

Header.defaultProps = {
  menuButton: null,
  backButton: null,
  userButton: null,
  subscriptionsButton: null,
  logoWrapper: null,
  mobileStyle: false,
};

Header.displayName = 'Header';

export default Header;
